<template>
  <lifecycle-form
    @close="cancel"
    @save="save"
  />
</template>
<script>
import LifecycleForm from './Form.vue'

export default {
  name: 'AddLifecycle',
  components: { LifecycleForm },
  data() {
    return {
      bucket: null,
      accountId: 0,
    }
  },
  computed: {
    bucketName() {
      return this.$route.params.id
    },
  },
  created() {
    this.accountId = this.$route.params.accountId
    this.bucket = this.$route.params.id
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'bucket-settings', id: this.bucket })
    },
    save(lifecycle) {
      this.$store
        .dispatch('accountLifecycle/addLifecycle', {
          accountId: this.accountId,
          query: {
            name: this.bucketName,
            lifecycle,
          },
        })
        .then(() => {
          this.cancel()
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while adding lifecycle rule.',
          )
        })
    },
  },
}
</script>
